'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _applyBind = require('./applyBind');

var _applyBind2 = _interopRequireDefault(_applyBind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * throttle
 * @param {Function} fn 需要调用的函数
 * @param {Number} delay 延迟时间，单位毫秒
 * @param {Boolean} immediate
 * true：表示首次调用返回值方法时，会马上调用fn
 * false：仅会记录当前时刻，当第二次调用的时间间隔超过wait时，才调用fn。
 * @param {Boolean} trailing
 * true：表示当调用方法时，未到达wait指定的时间间隔，则启动计时器延迟调用fn函数，
 * 若后续在既未达到delay指定的时间间隔和fn函数又未被调用的情况下调用返回值方法，则被调用请求将被丢弃。
 */
function throttle(fn, delay, immediate, trailing) {
    var options = {
        fn: fn,
        delay: delay,
        immediate: immediate,
        trailing: trailing,
        context: undefined,
        arguments: undefined,
        previous: 0,
        timer: undefined
    };
    return function () {
        var now = +new Date();
        if (!options.previous && options.immediate === false) {
            options.previous = now;
        }
        var remaining = options.delay - (now - options.previous);
        options.context = this;
        options.arguments = arguments;
        if (remaining <= 0 || remaining > options.delay) {
            if (options.timer) {
                clearTimeout(options.timer);
                options.timer = null;
            }
            options.previous = now;
            options.fn.apply(options.context, options.arguments);
            options.context = options.arguments = null;
        } else if (!options.timer && options.trailing !== false) {
            options.timer = setTimeout((0, _applyBind2.default)(later, options), remaining);
        }
    };
} /**
   * 频率控制 返回函数连续调用时，fn 执行频率限定为每多少时间（ms）执行一次
   */

function later() {
    this.previous = this.immediate === false ? 0 : +new Date();
    this.timer = null;
    this.fn.apply(this.context, this.arguments);
    if (this.context && this.arguments) {
        this.context = this.arguments = null;
    }
}

exports.default = throttle;


//////////////////
// WEBPACK FOOTER
// ./src/lib/utils/throttle.js
// module id = 172
// module chunks = 0